const ICONS = {
  "amazonwebservices": "devicon-amazonwebservices-plain-wordmark",
  "bootstrap": "devicon-bootstrap-plain",
  "chrome": "devicon-chrome-plain",
  "devicon": "devicon-devicon-plain",
  "css3": "devicon-css3-plain",
  "git": "devicon-git-plain",
  "github": "devicon-github-original",
  "homebrew": "devicon-homebrew-plain",
  "html5": "devicon-html5-plain",
  "javascript": "devicon-javascript-plain",
  "mysql": "evicon-mysql-original",
  "nodejs": "devicon-nodejs-plain",
  "npm": "devicon-npm-original-wordmark",
  "postgresql": "devicon-postgresql-plain",
  "postman": "devicon-postman-plain",
  "rails": "devicon-rails-plain",
  "react": "devicon-react-original",
  "reactbootstrap": "devicon-reactbootstrap-original",
  "reactrouter": "devicon-reactrouter-plain",
  "ruby": "devicon-ruby-plain",
  "vscode": "devicon-vscode-plain"
};

export default ICONS